import PropTypes from 'prop-types';
import React, { useState } from 'react';
import style from '../../../../assets/styles/questionListModal.module.css';
import polygon from '../../../../assets/images/polygon.svg';

const FilterModal = ({
  isOpen,
  onClose,
  onConfirm,
  data,
  isDuplicatePreview,
  statusValue,
  setStatusValue,
  filterValue,
  setFilterValue,
}) => {
  const [error, setError] = useState('');

  // Handle dropdown selection
  const handleChange = (e) => {
    setStatusValue(e.target.value);
    setError(null); // Clear error on valid selection
  };

  // Confirm selection and trigger callback
  const handleConfirm = () => {
    if (!statusValue) {
      setError('Please select a status.'); // Set error if no selection
      return;
    }

    if (statusValue) {
      onConfirm(statusValue);
      onClose(false);
    }
  };
  const handleOnReset = () => {
    setStatusValue('');
    setError(null);
    onConfirm('reset');
    onClose(false);
    setFilterValue('');
  };

  return (
    <>
      {isOpen && (
        <div
          className={`${style.modalBackdrop} ${isOpen ? style.show : ''} ${isDuplicatePreview ? style.previewBackdrop : ''}`}
        >
          <div className={`${style.modelBaseFilter} ${isOpen ? style.show : ''}`}>
            {isDuplicatePreview && <img src={polygon} alt="polygon" className={style.polyImg} />}
            {!isDuplicatePreview && (
              <div className={style.modalHeader}>
                <span style={{ marginLeft: 20, fontWeight: 400, fontSize: 14 }} className={style.modalTitle}>
                  {' '}
                  <svg
                    style={{ position: 'relative', top: 5 }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.39844 2.10156H18.5984C19.6984 2.10156 20.5984 3.00156 20.5984 4.10156V6.30156C20.5984 7.10156 20.0984 8.10156 19.5984 8.60156L15.2984 12.4016C14.6984 12.9016 14.2984 13.9016 14.2984 14.7016V19.0016C14.2984 19.6016 13.8984 20.4016 13.3984 20.7016L11.9984 21.6016C10.6984 22.4016 8.89844 21.5016 8.89844 19.9016V14.6016C8.89844 13.9016 8.49844 13.0016 8.09844 12.5016L4.29844 8.50156C3.79844 8.00156 3.39844 7.10156 3.39844 6.50156V4.20156C3.39844 3.00156 4.29844 2.10156 5.39844 2.10156Z"
                      stroke="#212529"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>{' '}
                  Filter
                </span>
                <button
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onClose(false);
                      setError(null);
                    }
                  }}
                  className={style.modalClose}
                  onClick={() => {
                    onClose(false);
                    setError(null);
                    if (!filterValue) {
                      setStatusValue('');
                    }
                  }}
                >
                  &#10005;
                </button>
              </div>
            )}
            <div className={style.modelBaseFilterContents}>
              <label htmlFor="selectQBBank">Status</label>
              <br />
              <select id="selectQBBank" className={style.modalSelect} onChange={handleChange} value={statusValue ?? ''}>
                <option value="" disabled>
                  Select status
                </option>
                {['Active', 'Inactive']?.map((items, i) => (
                  <option key={items} value={items}>
                    {items}
                  </option>
                ))}
              </select>
              {/* Display error message */}
              {error && <div className={style.errorText}>{error}</div>}
            </div>
            <div className={style.modalBaseFilterButtons}>
              <button className={style.modalCancelBtn} onClick={handleOnReset}>
                Reset Filter
              </button>
              <button className={style.modalDuplicateBtn} onClick={handleConfirm}>
                Apply Filter
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

FilterModal.propTypes = {
  data: PropTypes.any,
  isDuplicatePreview: PropTypes.any,
  isOpen: PropTypes.any,
  onClose: PropTypes.func,
  onConfirm: PropTypes.any,
  setStatusValue: PropTypes.func,
  statusValue: PropTypes.string,
};

export default FilterModal;
